"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationSchema = exports["default"] = exports.PasswordInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _EyeOff = _interopRequireDefault(require("../Icons/EyeOff"));
var _RemoveRedEye = _interopRequireDefault(require("@material-ui/icons/RemoveRedEye"));
var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));
var _SetPassword = require("../SignUp/SetPassword");
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _i18next = _interopRequireDefault(require("i18next"));
var _Button = _interopRequireDefault(require("../Button"));
var _reactI18next = require("react-i18next");
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _excluded = ["className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var validationSchema = exports.validationSchema = Yup.object().shape({
  password: Yup.string().matches(_SetPassword.PASSWORD_REGEX, _i18next["default"].t('signup.form.password.invalidCharacters')).min(6, _i18next["default"].t('signup.form.password.length')).max(128, _i18next["default"].t('signup.form.password.length')).required('Required')
});
var PasswordInput = exports.PasswordInput = function PasswordInput(_ref) {
  var className = _ref.className,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShowPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var IconComponent = isShowPassword ? _EyeOff["default"] : _RemoveRedEye["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('border rounded flex p-1 items-center bg-app dark:bg-secondary', className)
  }, /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    fontSize: "small",
    className: "text-primary mx-1"
  }), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    autoFocus: true,
    type: "text",
    style: {
      webkitTextSecurity: isShowPassword ? 'none' : 'disc'
    },
    className: "flex-grow text-gray-medium bg-transparent",
    placeholder: "Password",
    autoComplete: "off"
  }, otherProps)), /*#__PURE__*/_react["default"].createElement(IconComponent, {
    fontSize: "small",
    className: "mx-1 cursor-pointer text-gray-medium",
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      setShowPassword(function (show) {
        return !show;
      });
    }
  }));
};
var _default = exports["default"] = function _default(_ref2) {
  var _ref2$defaultPassword = _ref2.defaultPassword,
    defaultPassword = _ref2$defaultPassword === void 0 ? '' : _ref2$defaultPassword,
    onChangePassword = _ref2.onChangePassword,
    onCancel = _ref2.onCancel,
    _ref2$noCancel = _ref2.noCancel,
    noCancel = _ref2$noCancel === void 0 ? false : _ref2$noCancel;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    id: "attachmentPasswordForm",
    onSubmit: function onSubmit(v) {
      return onChangePassword(v.password);
    },
    initialValues: {
      password: defaultPassword
    },
    validationSchema: validationSchema
  }, function (_ref3) {
    var errors = _ref3.errors,
      touched = _ref3.touched,
      values = _ref3.values,
      isValid = _ref3.isValid,
      handleChange = _ref3.handleChange,
      handleSubmit = _ref3.handleSubmit;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(PasswordInput, {
      name: "password",
      className: values.password !== defaultPassword && !isValid ? 'border-red' : '',
      value: values.password,
      onChange: handleChange,
      onKeyDown: function onKeyDown(e) {
        return e.key === 'Enter' && handleSubmit(e);
      }
    })), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, !noCancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      color: "white",
      className: "w-24",
      size: "sm",
      onClick: onCancel
    }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      disabled: !isValid,
      onClick: handleSubmit,
      color: "primary",
      className: "ml-4 w-24",
      size: "sm"
    }, t('button.okay'))));
  });
};
//# sourceMappingURL=index.js.map